import { makeStyles, tokens } from "@fluentui/react-components";

export const useStyle = makeStyles({
	checkboxItem: {
		">:first-child": {
			order: 3,
		},
	},
	desireHeader: {
		fontWeight: tokens.fontWeightSemibold,
		fontSize: tokens.fontSizeBase400,
	},
	popoverContent: {
		minWidth: "11.25rem",
	},
	desire: {
		cursor: "pointer",
	},
});
